// --------------------------
// IMPORTS
// --------------------------
import { useEffect, useRef, useState } from "react";

// --------------------------
// MAIN COMPONENT
// --------------------------
export default function LogViewer() {
  //Dispatch + Custom Hooks
  const logEndRef = useRef(null);

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [logs, setLogs] = useState([]);

  // --------------------------
  // LOCAL VARIABLES
  // --------------------------

  const getColor = (line) => {
    if (line.startsWith("[ERROR]")) return "#ff4d4f";
    if (line.startsWith("[WARN]")) return "#faad14";
    return "#0f0";
  };

  // --------------------------
  // USE EFFECTS
  // --------------------------
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await fetch(process.env.REACT_APP_BACKEND + "/logs");
        const data = await res.json();
        setLogs(data.logs || []);
      } catch (err) {
        console.error("Failed to fetch logs:", err);
      }
    };

    fetchLogs();

    const interval = setInterval(fetchLogs, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    logEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [logs]);
  const displayedLogs = logs.slice();
  return (
    <div
      style={{
        background: "#111",
        color: "#0f0",
        padding: "20px",
        height: "90vh",
        overflowY: "scroll",
        fontFamily: "monospace",
        fontSize: "14px",
      }}
    >
      {displayedLogs.map((line, idx) => (
        <div key={idx} style={{ color: getColor(line) }}>
          {line}
        </div>
      ))}
      <div ref={logEndRef} />
    </div>
  );
}
